package com.dotdrives.repository

import com.dotdrives.client.RecurringScheduleClient
import com.dotdrives.model.RecurringSchedulePage

fun interface RecurringScheduleRepository {
    suspend fun list(orgId: String, giverId: String?, status: String, query: String, offset: Int, limit: Int): Result<RecurringSchedulePage>
}

class SupabaseRecurringScheduleRepository(private val client: RecurringScheduleClient = RecurringScheduleClient()) : RecurringScheduleRepository {
    override suspend fun list(orgId: String, giverId: String?, status: String, query: String, offset: Int, limit: Int) =
        runCatching { client.list(orgId, giverId, status, query, offset, limit) }
}
